import React, { useState } from "react";
import { Button } from "./ui/button";
import { Share2 } from "lucide-react";
import { shareItem } from "../lib/native";
import { toast } from "sonner";

/**
 * Compact "Share" button that opens the native Android share sheet on the
 * APK and falls back to navigator.share / clipboard on the web.
 *
 * Props
 *   title       Optional title passed to the OS share sheet
 *   text        Optional pre-filled message body
 *   url         URL to share (Receipt link / Agreement PDF / Referral link)
 *   label       Visible button label (default: "Share")
 *   variant     "default" | "outline" | "ghost"
 *   size        "sm" | "default"
 *   className   Extra Tailwind classes
 *   testid      data-testid
 */
export default function NativeShareButton({
  title, text, url, label = "Share", variant = "outline", size = "sm",
  className = "", testid = "native-share-btn",
}) {
  const [busy, setBusy] = useState(false);

  const onClick = async () => {
    if (busy) return;
    setBusy(true);
    try {
      const result = await shareItem({ title, text, url, dialogTitle: title || "Share" });
      if (result === "copied") toast.success("Link copied to clipboard");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button
      type="button"
      size={size}
      variant={variant}
      onClick={onClick}
      disabled={busy}
      className={className}
      data-testid={testid}
    >
      <Share2 className="w-4 h-4 mr-1.5" />
      {label}
    </Button>
  );
}
